/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

declare const VALID_LAYOUT_VALUES: readonly ['fill', 'fixed', 'intrinsic', 'responsive', undefined];
declare type LayoutValue = typeof VALID_LAYOUT_VALUES[number];
declare type ImgElementStyle = NonNullable<JSX.IntrinsicElements['img']['style']>;

interface ImageProps {
    width?: number;
    height?: number;
    alt: string;
    src: any;
    className?: string;
    imgClassName?: string;
    layout?: LayoutValue;
    objectFit?: ImgElementStyle['objectFit'];
    objectPosition?: ImgElementStyle['objectPosition'];
    maxWidth?: ImgElementStyle['maxWidth'];
    maxHeight?: ImgElementStyle['maxHeight'];
    minWidth?: ImgElementStyle['minWidth'];
}

export default function Image(props: ImageProps): JSX.Element {
    const {
        src,
        alt,
        width,
        height,
        className,
        imgClassName,
        layout,
        objectFit,
        minWidth = null,
        maxWidth = '100%',
        maxHeight = '100%',
    } = props;

    const imgHeight = objectFit === 'cover' ? '100%' : height;

    return (
        <div
            className={`${className ? className : ''} ${
                layout === 'fill' ? 'block overflow-hidden absolute top-0 left-0 bottom-0 right-0 box-border m-0' : ''
            }`}
        >
            <img
                src={src}
                alt={alt}
                className={`${imgClassName ? imgClassName : ''} ${
                    objectFit === 'cover'
                        ? 'absolute top-0 left-0 bottom-0 right-0 box-border object-cover object-center w-full'
                        : ''
                }`}
                style={{ maxWidth: maxWidth || minWidth, maxHeight: maxHeight, height: imgHeight, minWidth: minWidth }}
                height={height}
                width={width}
            />
        </div>
    );
}
